"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlippageMode = exports.SquidCallType = exports.SquidRouteType = void 0;
var SquidRouteType;
(function (SquidRouteType) {
    SquidRouteType["CALL_BRIDGE_CALL"] = "CALL_BRIDGE_CALL";
    SquidRouteType["CALL_BRIDGE"] = "CALL_BRIDGE";
    SquidRouteType["BRIDGE_CALL"] = "BRIDGE_CALL";
    SquidRouteType["BRIDGE"] = "BRIDGE";
    SquidRouteType["EVM_ONLY"] = "EVM_ONLY";
    SquidRouteType["COSMOS_ONLY"] = "COSMOS_ONLY";
})(SquidRouteType = exports.SquidRouteType || (exports.SquidRouteType = {}));
var SquidCallType;
(function (SquidCallType) {
    SquidCallType[SquidCallType["DEFAULT"] = 0] = "DEFAULT";
    SquidCallType[SquidCallType["FULL_TOKEN_BALANCE"] = 1] = "FULL_TOKEN_BALANCE";
    SquidCallType[SquidCallType["FULL_NATIVE_BALANCE"] = 2] = "FULL_NATIVE_BALANCE";
    SquidCallType[SquidCallType["COLLECT_TOKEN_BALANCE"] = 3] = "COLLECT_TOKEN_BALANCE";
})(SquidCallType = exports.SquidCallType || (exports.SquidCallType = {}));
var SlippageMode;
(function (SlippageMode) {
    SlippageMode[SlippageMode["AGGRESSIVE"] = 0] = "AGGRESSIVE";
    SlippageMode[SlippageMode["NORMAL"] = 1] = "NORMAL";
    SlippageMode[SlippageMode["FLEXIBLE"] = 2] = "FLEXIBLE";
})(SlippageMode = exports.SlippageMode || (exports.SlippageMode = {}));
//# sourceMappingURL=index.js.map